<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="user !== null">

    <div class="p-grid">
      <div class="p-col-6">
        <h2>{{ t('common.labels.languages') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button [withRight]="editRight" *ngIf="user.showAdditionalData()" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">
      <div class="p-grid checkbox-list checkbox-no-ban">
        <div *ngFor="let language of languages" class="p-col-12 p-md-6">
          <app-form-control [cid]="language.name" [control]="language.control" [type]="'checkbox'" [label]="language.name" [edit]="inEdit" [basevalue]="language.control.value"></app-form-control>
        </div>
      </div>

      <hr>
      <h2>{{ t('common.labels.locations') }}</h2>

      <div class="p-grid checkbox-list checkbox-no-ban">
        <div *ngFor="let location of locations" class="p-col-12 p-md-6">
          <div class="p-grid">
            <div class="p-col-6 p-md-4">
              <app-form-control [cid]="location.name + '_value'" [control]="location.control_value" [type]="'checkbox'" [label]="location.name" [edit]="inEdit" [basevalue]="location.control_value.value"></app-form-control>
            </div>
            <div class="p-col-6 p-md-4">
              <app-form-control [cid]="location.name + '_prio'" [control]="location.control_priority" [type]="'select'" [options]="priorities" [label]="t('common.labels.priority')" [edit]="inEdit" [inline]="true" [basevalue]="location.control_priority.value"></app-form-control>
            </div>
          </div>
        </div>
      </div>

      <div class="p-grid p-mt-4">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'additional_locations'" [control]="form.get('additional_locations')" [type]="'input'" [label]="t('common.labels.additional_locations')" [edit]="inEdit" [basevalue]="user.getMisc('additional_locations', '-')"></app-form-control>
        </div>
      </div>

    </ng-container>

  </form>
</ng-container>
